document.addEventListener("DOMContentLoaded", () => {

    const cards = document.querySelectorAll(".hgp-festival-card");

    if(cards.length){

        const observer = new IntersectionObserver(entries => {

            entries.forEach(entry=>{

                if(!entry.isIntersecting) return;

                entry.target.classList.add("show");

                observer.unobserve(entry.target);

            });

        },{

            threshold:.15

        });

        cards.forEach((card,index)=>{

            card.style.transitionDelay=`${index*80}ms`;

            observer.observe(card);

        });

    }


    const btn=document.querySelector(".hgp-festival-load-more");

    if(!btn) return;

    btn.addEventListener("click",()=>{

        document
        .querySelectorAll(".hgp-hidden-mobile")
        .forEach(card=>{

            card.classList.add("show-mobile");

        });

        btn.style.display="none";

    });

});